import {
  POWER_POOL_NAME,
  PULSE_POOL_NAME
} from '../../../solaris-lens-common-lib/src/constants/services';

/**
 * Resolves the pool name used to validate external-link access.
 * Pulse links are granted via the Power pool in the user profile.
 * @param {string} poolName
 * @returns {string}
 */
export const getExternalLinkAccessPoolName = poolName =>
  poolName === PULSE_POOL_NAME ? POWER_POOL_NAME : poolName;
